// Soft, non-blocking character guardrail for note editors. Past this many characters the
// RichTextEditor counter turns red + bold to nudge against very long notes, but typing is never
// capped (the backend note column is LONGTEXT).
export const NOTE_SOFT_LIMIT = 10000;
